import {
  Radio,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Stack,
} from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { PassHolderFormData } from "../../schema"

const PassSelectionField = () => {
  const { t } = useTranslation()

  const { control } = useFormContext<PassHolderFormData>()

  return (
    <FormControl
      component="fieldset"
      sx={{ border: 0, p: 0, m: 0, minWidth: 0 }}
    >
      <FormLabel
        component="legend"
        sx={{ typography: "body2", fontWeight: "bold", color: "text.primary" }}
      >
        {t("passHolderDetails.form.chooseCardType")}
      </FormLabel>
      <Controller
        name="passSelection"
        control={control}
        render={({ field }) => (
          <RadioGroup {...field}>
            <Stack direction="row" spacing={1}>
              <FormControlLabel
                value="existing"
                control={<Radio />}
                label={t("passHolderDetails.form.existingCard")}
              />
              <FormControlLabel
                value="new"
                control={<Radio />}
                label={t("passHolderDetails.form.newCard")}
              />
            </Stack>
          </RadioGroup>
        )}
      />
    </FormControl>
  )
}

export default PassSelectionField
